export default "__VITE_ASSET__2601ae18__"